import SetupPage from './SetupPage'
import SetupTab from './SetupTab'
import SetupSearch from './SetupSearch'
import SetupList from './SetupList'
import SetupMasterDetail from './SetupMasterDetail'

export { SetupPage, SetupList, SetupTab, SetupSearch, SetupMasterDetail };



// WEBPACK FOOTER //
// ./src/areas/shared/pages/setup/index.js